<template>
  <iStyledCard
    :splash-image="entity.imageUrl || DEFAULT_SPLASH_IMAGE"
    :height="height"
    :width="width"
    :splash-image-min-height="170"
    :splash-image-max-height="170"
    :default-href="entity.destinationUrl"
    :description="entity.description"
    :metrics="metrics"
    badge="Boosted"
  >
    <template #title-section>
      <iRow align="between" vertical-align="middle" wrap="nowrap">
        <iColumn>
          <iRow vertical-align="middle" wrap="nowrap">
            <iColumn gap="none" width="hug">
              <iLink :hover-underline="false" :href="entity.destinationUrl">
                <iSubHeading class="subheading" font-weight="dark">
                  {{ entity.title }}
                </iSubHeading>
              </iLink>
              <iText variant="subtle">
                {{ sponsoredByText }}
              </iText>
            </iColumn>
          </iRow>
        </iColumn>
        <iDropdownMenu
          :items="dropdownItems"
          :show-dropdown="isDropdownOpen"
          position="right"
          teleport-to-body
          @close="closeDropdown"
          @click="handleAction"
        >
          <template #trigger>
            <iIcon icon="dots-vertical" @click="openDropdown" />
          </template>
        </iDropdownMenu>
      </iRow>
    </template>
  </iStyledCard>
</template>

<script>
import { DEFAULT_SPLASH_IMAGE } from "%/constants/publication-constants";
import { Enum } from "@vcl";
import { mapState } from "pinia";
import { usePublicationStore } from "@/stores/publication-store";
import { MenuConstants } from "@bloglovin/vue-component-library";

export default {
  name: "NativeAdCardLarge",
  props: {
    entity: {
      type: Object,
      required: true,
    },
    width: {
      type: [Number, Enum],
      required: false,
      default: "hug",
      options: ["fill", "hug"],
    },
    height: {
      type: [Number, Enum],
      required: false,
      default: "hug",
      options: ["fill", "hug"],
    },
  },
  data() {
    return {
      DEFAULT_SPLASH_IMAGE,
      isDropdownOpen: false,
    };
  },
  computed: {
    ...mapState(usePublicationStore, ["publicationName"]),
    sponsoredByText() {
      return `${this.entity.sponsoredByPrefix}: ${this.publicationName}`;
    },
    dropdownItems() {
      return [
        {
          name: "remove",
          label: "Delete Ad",
          actionType: MenuConstants.ACTION_TYPE_BUTTON_CLICK,
          actionValue: "remove",
        },
      ];
    },
    metrics() {
      return [
        { name: "Impressions", value: 1230 },
        { name: "Clicks", value: 200 },
        { name: "Subscriptions", value: 12 },
        { name: "Boost ", value: "$500" },
        { name: "Revenue", value: "$1200" },
        { name: "Commissions", value: "$500" },
        { name: "ROI", value: "$200" }, // revenue - commisisois - boost
      ];
    },
  },
  methods: {
    openDropdown() {
      this.isDropdownOpen = true;
    },
    closeDropdown() {
      this.isDropdownOpen = false;
    },
    handleAction(action) {
      if (action === "remove") {
        // Implement this
      }
      this.closeDropdown();
    },
  },
  styleGuide: () => ({
    borderColor: { "color.border": "dark" },
    borderSize: { "size.border": "thin" },
    borderRadius: { "size.borderRadius": "large" },
    paddingTop: { "size.spacing": "large" },
    paddingLeft: { "size.spacing": "large" },
    paddingRight: { "size.spacing": "large" },
    paddingBottom: { "size.spacing": "large" },
  }),
};
</script>

<style scoped lang="scss">
.subheading {
  line-height: unset;
}

.ad-details {
  padding-top: v-bind("$getStyles.paddingTop");
  padding-left: v-bind("$getStyles.paddingLeft");
  padding-right: v-bind("$getStyles.paddingRight");
  padding-bottom: v-bind("$getStyles.paddingBottom");
}
</style>
